import { render, staticRenderFns } from "./InstructorFormModal.vue?vue&type=template&id=033b5d8f&scoped=true&"
import script from "./InstructorFormModal.vue?vue&type=script&lang=ts&"
export * from "./InstructorFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorFormModal.vue?vue&type=style&index=0&id=033b5d8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b5d8f",
  null
  
)

export default component.exports